import React from 'react';
import cls from 'classnames';
import Section from '../../Section';
import { publicPath } from '@/utils';
import styles from './index.module.scss';

const Thumbnail = ({
  className,
  name,
  data,
  reverse
}) => /*#__PURE__*/React.createElement(Section, {
  name: name,
  className: cls(styles.container, className, {
    [styles.reverse]: reverse
  })
}, /*#__PURE__*/React.createElement("div", {
  className: styles.text
}, /*#__PURE__*/React.createElement("h1", null, data.title), /*#__PURE__*/React.createElement("ul", null, data.briefs.map((brief, index) => /*#__PURE__*/React.createElement("li", {
  key: index
}, /*#__PURE__*/React.createElement("h4", null, brief.title), brief.desc && /*#__PURE__*/React.createElement("p", null, brief.desc))))), /*#__PURE__*/React.createElement("div", {
  className: styles.image
}, /*#__PURE__*/React.createElement("img", {
  src: publicPath(data.img)
})));

export default Thumbnail;